var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showList
      ? _c(
          "div",
          { staticClass: "rightPanel" },
          _vm._l(_vm.invoices.list, function (i) {
            return _c(
              "div",
              {
                staticClass: "invoiceBlock",
                on: { click: () => _vm.openInvoice(i.id) },
              },
              [
                _c("p", [_c("strong", [_vm._v(_vm._s(i.id))])]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(i.countryName))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Препаратов: "),
                  _c("strong", [_vm._v(_vm._s(i.drugs))]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("На сумму: "),
                  _c("strong", [_vm._v(_vm._s(i.sum))]),
                  _vm._v(" " + _vm._s(i.currency)),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }